export const ScreenSize = {
	phone: 560,
	tablet: 800,
	laptop: 1100,
};
